import { put, takeLatest } from 'redux-saga/effects';

import * as constants from './constants';
import { getAlarms } from '../../api/alarmsHistory';
import { actionStatus, statusAction, getError } from '../utils';
import { addNotification } from '../ui/notifications/actions';
import { NOTIFICATION_TYPE_INTERACTION } from '../../attrs/notifications';
import { generateId } from '../../helpers/utils';
import { setAlarmsSortOrder } from './actions';

function* handleLoadAlarms({ page, limit, sort, order, machineIds, periodTime, productionLines, sensors }) {
  yield put(statusAction(constants.LOAD_ALARMS, actionStatus.START));
  try {
    const { data } = yield getAlarms(page, limit, sort, order, machineIds, periodTime, productionLines, sensors);
    yield put(statusAction(constants.LOAD_ALARMS, actionStatus.SUCCESS, { payload: data }));
  } catch (err) {
    const error = getError(err);
    yield put(
      statusAction(constants.LOAD_ALARMS, actionStatus.ERROR, {
        message: error
      })
    );

    yield put(
      addNotification({
        key: generateId(),
        type: actionStatus.ERROR,
        message: `errors.alerts.${error}`,
        notificationType: NOTIFICATION_TYPE_INTERACTION
      })
    );
  }
}

function* handleFetchFiltered({ page, limit, sort, order, machineIds, periodTime, productionLines, sensors }) {
  yield put(statusAction(constants.LOAD_ALARMS_WITH_FILTER, actionStatus.START));
  try {
    const { data } = yield getAlarms(page, limit, sort, order, machineIds, periodTime, productionLines, sensors);
    yield put(setAlarmsSortOrder(sort, order));
    yield put(statusAction(constants.LOAD_ALARMS_WITH_FILTER, actionStatus.SUCCESS, { payload: data }));
  } catch (err) {
    const error = getError(err);
    yield put(
      statusAction(constants.LOAD_ALARMS_WITH_FILTER, actionStatus.ERROR, {
        message: error
      })
    );

    yield put(
      addNotification({
        key: generateId(),
        type: actionStatus.ERROR,
        message: `errors.alerts.${error}`,
        notificationType: NOTIFICATION_TYPE_INTERACTION
      })
    );
  }
}

export function* watchLoadOrders() {
  yield takeLatest(constants.LOAD_ALARMS, handleLoadAlarms);
  yield takeLatest(constants.LOAD_ALARMS_WITH_FILTER, handleFetchFiltered);
}
